package com.evoapps.evoshift.ui.login

internal actual fun focusesFirstFieldOnStart(wideWindow: Boolean): Boolean = wideWindow
